import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SignIn from "./component/signin/SignIn";
import Email from "./component/email/EmailVerification";
import PasswordVerfication from "./component/password/PasswordVerification";
import HomePremium from "./component/homepremium/HomePremium";
import ViewPlans from "./component/viewplans/ViewPlans";
import ThankYou from "./component/confirmbooking/ThankYou";
import ClinicianComponent from "./component/registration/clinician/cliniciancomponent/ClinicianComponent";
import ForgotPassword from "./component/password/ForgotPassword";
import ChangePassword from "./component/password/ChangePassword";
import UnauthenticatedUser from "./component/commoncomponents/UnauthenticatedUser";
import ViewPlansHome from "./component/viewplans/ViewPlansHome";
import Snackbar from "./component/commoncomponents/alert/Snackbar";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import snackbarReducer from "./component/commoncomponents/alert/SnackbarReducer";
import registraionReducer from "./component/registration/RegistraionReducer";
import { Provider } from "react-redux";
import OrganizationMain from "./component/registration/organzation/OrganizationMain";
import ServiceComponent from "./component/registration/service/servicemain/ServiceComponent";
import ServiceTypeComponent from "./component/registration/servicetype/servicetypemain/ServiceTypeComponent";
import UserComponent from "./component/registration/userservice/usercomponent/UserComponent";
import HpSchedulingComponent from "./component/registration/hpscheduling/hpschedulingcomponent/HpSchedulingComponent";
import HPWeeklyTimingTabs from "./component/registration/clinician/clinciantiming/HPWeeklyTimingTabs";
import PaymentSuccess from "./component/registration/payment/PaymentSuccess";
import PaymentInprogress from "./component/registration/payment/PaymentInprogress";
import PaymentFailed from "./component/registration/payment/PaymentFailed";
import WelcomePack from "./component/viewplans/WelcomePack";
import QrCode from "./component/registration/clinician/QrCode/QrCode";
import ViewPlansRegistration from "./component/viewplans/ViewPlansRegistration";
import ReactGA from "react-ga4";
import GenerateQrCodes from "./component/registration/clinician/QrCode/GenerateQrCodes";
import { useEffect } from "react";

const reducer = combineReducers({
  snackbar: snackbarReducer,
  organization: registraionReducer,
  service: registraionReducer,
  serviceType: registraionReducer,
  user: registraionReducer,
  payment: registraionReducer,
  paymentEndDate: registraionReducer,
  paymentSortedDate: registraionReducer,
});

const TRACKING_ID = "G-DLQBCCSCMM";
ReactGA.initialize(TRACKING_ID);

const store = configureStore({
  reducer
}
  
);
function App() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <Provider store={store}>
      {/* <Router basename="/CellmaFlexPremium"> */}
      <Router basename="/CellmaFlexPremium">
        <Snackbar />
        <Routes>
          <Route path="/signin" element={<SignIn />} />

          <Route path="/email" element={<Email />} />

          <Route path="/password" element={<PasswordVerfication />} />

          <Route path="/" element={<HomePremium />} />

          <Route path="/ViewPlans" element={<ViewPlansRegistration />} />

          <Route path="/ViewPlansHome" element={<ViewPlansHome />} />

          <Route path="/ViewPremiumPlans" element={<ViewPlans />} />

          <Route path="/ThankYou" element={<ThankYou />} />

          <Route path="/organization" element={<OrganizationMain />} />

          <Route path="/service" element={<ServiceComponent />} />

          <Route path="/servicetype" element={<ServiceTypeComponent />} />

          <Route path="/userservice" element={<UserComponent />} />

          <Route path="/hpscheduling" element={<HpSchedulingComponent />} />

          <Route path="/clinician" element={<ClinicianComponent />} />

          <Route path="/clinicianscheduling" element={<HPWeeklyTimingTabs />} />

          <Route path="/forgotpassword" element={<ForgotPassword />} />

          <Route path="/changepassword" element={<ChangePassword />} />

          <Route path="/paymentinprogress" element={<PaymentInprogress />} />

          <Route path="/paymentfailed" element={<PaymentFailed />} />

          <Route path="/paymentsuccess" element={<PaymentSuccess />} />

          <Route path="/welcomepack" element={<WelcomePack />} />

          <Route path="/qrcode" element={<QrCode />} />

          <Route path="/generateQrCodes" element={<GenerateQrCodes />} />

          <Route path="/*" element={<UnauthenticatedUser />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
